import { render, staticRenderFns } from "./ApplicationPersonInfo.vue?vue&type=template&id=1916158e&scoped=true&"
import script from "./ApplicationPersonInfo.vue?vue&type=script&lang=js&"
export * from "./ApplicationPersonInfo.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationPersonInfo.vue?vue&type=style&index=0&id=1916158e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1916158e",
  null
  
)

export default component.exports